import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IoniconsOutline } from '@pt/pt-models';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pt-navbar-user-item-layout',
  template: `
    <div class="user-item-container">
      <div class="header">
        <div class="org-name">
          {{ orgName }}
        </div>
        <button class="btn btn-sm btn-link" (click)="clickSignOut.emit(true)">
          {{ 'NAVBAR.SIGNOUT' | translate }}
        </button>
      </div>
      <div class="body">
        <table>
          <tr>
            <td>
              <div class="icon-col">
                <pt-icon
                  class="icon"
                  style="color:#727272;"
                  [key]="IconUser"
                  [size]="60"
                ></pt-icon>
              </div>
            </td>
            <td class="text-row">
              <div class="profile">
                <span class="username text-ellipsis" ngbTooltip="{{ username }}"
                  >{{ username }}
                </span>
                <span class="text-ellipsis" ngbTooltip="{{ email }}"
                  >{{ email }}
                </span>
                <button
                  class="btn btn-sm btn-link link"
                  (click)="clickProfile.emit(true)"
                >
                  {{
                    (isExternalUserManagement
                      ? 'NAVBAR.PROFILE_DETAILS'
                      : 'NAVBAR.PROFILE'
                    ) | translate
                  }}
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  `,
  styleUrls: [`navbar-user-item-layout.component.scss`],
})
export class NavbarUserItemLayoutComponent {
  @Output() clickSignOut = new EventEmitter<boolean>();
  @Output() clickProfile = new EventEmitter<boolean>();

  IconUser = IoniconsOutline.userCircle;

  @Input() username?: string;
  @Input() name?: string;
  @Input() surname?: string;
  @Input() email?: string;
  @Input() orgName?: string;
  @Input() admin = false;
  @Input() system = false;
  @Input() isMicrosoftModule = false;
  @Input() isExternalUserManagement = false;
}
